// Injects the dictation domain's analytics emitters into @heidi/dictate's
// analytics-ports seam. Imported for effect in `_app.tsx`, beside the bridge
// wiring.
//
// ROUTING IS PRESERVED, NOT NORMALIZED. Each host below is the app emit host
// the deferred cone already reached through, dispatched with exactly the
// options it passes today: the session trio passes NONE (Amplitude stays on —
// three live Amplitude series), the CSAT trio passes `{ amplitude: false }`.
// The two are deliberately not normalized against each other, and the wiring
// test pins every member by identity so a wrapper cannot slip in between.
//
// Every member is a REFERENCE to the host fn, never a re-implementation: a
// re-implemented emitter would change routing or payload silently.

import { trackUnscopedButtonClicked } from '@/components/ui/tracked-button-click';
import { trackButtonClicked } from '@/lib/analytics/scribe/button';
import { trackFieldSelected } from '@/lib/analytics/scribe/ui';
import {
  trackDictateReengagementViewed,
  useDictateReengagementViewExposure,
} from '@/models/analytics/features/dictate-reengagement-analytics';
import { dictateOnboardingAnalyticsPorts } from '@/models/analytics/features/trackDictateOnboardingAnalytics';
import { dictationCsatAnalyticsPorts } from '@/models/analytics/features/trackDictationCsatAnalytics';
import { dictationFeedbackAnalyticsPorts } from '@/models/analytics/features/trackDictationFeedbackAnalytics';
import { dictationLogsAnalyticsPorts } from '@/models/analytics/features/trackDictationLogsAnalytics';
import {
  dictationSessionEndPorts,
  trackDictationStarted,
} from '@/models/analytics/features/trackDictationSessionAnalytics';
import { configureDictationAnalyticsPorts } from '@heidi/dictate';

const tauriDictationAnalytics = {
  session: {
    trackStarted: trackDictationStarted,
    ...dictationSessionEndPorts,
  },
  csat: dictationCsatAnalyticsPorts,
  feedback: dictationFeedbackAnalyticsPorts,
  onboarding: dictateOnboardingAnalyticsPorts,
  // The two button helpers (Snowplow + Datadog routing) and the field wrapper,
  // all BY REFERENCE — their routing and options handling are theirs.
  ui: { trackButtonClicked, trackFieldSelected, trackUnscopedButtonClicked },
  logs: dictationLogsAnalyticsPorts,
  reengagement: {
    trackViewed: trackDictateReengagementViewed,
    useViewExposure: useDictateReengagementViewExposure,
  },
};

configureDictationAnalyticsPorts(tauriDictationAnalytics);

export { tauriDictationAnalytics };
